import apis from "./Api";
import withoutAuthApis from "./withoutAuthApi";
//Auth api
export function userLogin(credentials) {
  return withoutAuthApis
    .post(`/auth/login`, credentials, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      checkError(error);
      return error;
    });
}

function apiRequest(
  method,
  url,
  data = {},
  idToken = null,
  contentType = "application/json"
) {
  const headers = {
    "Content-Type": contentType,
  };

  if (idToken) {
    headers.Authorization = `Bearer ${idToken}`;
  }

  return apis[method](url, data, { headers })
    .then((res) => res.data)
    .catch((error) => {
      checkError(error);
      throw error;
    });
}

export function addProduct(productData, files, idToken) {
  let formData = new FormData();
  for (let key in productData) {
    formData.append(key, productData[key]);
  }
  if (files) {
    files.forEach((file) => {
      formData.append("images", file, file.name);
    });
  }
  return apiRequest(
    "post",
    "product/addProduct",
    formData,
    idToken,
    "multipart/form-data"
  );
}

export function editProduct(productData, id, files) {
  let formData = new FormData();
  for (let key in productData) {
    formData.append(key, productData[key]);
  }
  if (id) {
    formData.append("productId", id);
  }
  if (files) {
    files.forEach((file) => {
      formData.append("images", file, file.name);
    });
  }
  return apiRequest(
    "put",
    "product/updateProduct",
    formData,
    null,
    "multipart/form-data"
  );
}

export function getProductCategories(token) {
  return apiRequest("get", "/category/getAllCategories", token);
}

export function getBrandByCategory(categoryId, token) {
  return apiRequest(
    "get",
    `/master/getBrandByCategory/${categoryId}`,
    {},
    token
  );
}

export function addBrand(brandData, token) {
  return apiRequest(
    "post",
    "/brand/addBrand",
    brandData,
    token,
    "multipart/form-data"
  );
}

export function editBrand(editData, id) {
  return apiRequest("put", `/master/editBrand/${id}`);
}

export function deleteBrand(id) {
  return apiRequest("delete", `/master/deleteBrand/${id}`);
}

/**
 * Get all brands
 * @return {Promise} - Promise with response data
 */
export function getAllBrands(token) {
  return apiRequest("get", "/brand/getAllBrands", {}, token);
}

export function getAllProducts(params) {
  return apiRequest("get", "/product/getProducts", { params: params });
}

export function deleteProduct(categoryId) {
  return apiRequest("delete", `/master/deleteProduct/${categoryId}`);
}

export function getAccount() {
  return apiRequest("get", "/master/account");
}

export function getVerifyProductHistory() {
  return apiRequest("get", "/master/verifyProductHistory");
}

export function updateAccount(data, idToken) {
  return apiRequest(
    "put",
    "/user/editProfile",
    data,
    idToken,
    "application/x-www-form-urlencoded"
  );
}

export const AddProfilePicture = (data, idToken) => {
  let formData = new FormData();

  for (let key in data) {
    formData.append(key, data[key]);
  }

  return apiRequest(
    "post",
    "/user/addProfilePic",
    formData,
    idToken,
    "multipart/form-data"
  );
};

export const SignUpUser = (data) => {
  return withoutAuthApis
    .post(`/auth/signup`, data)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      checkError(error);
      throw error;
    });
};

export function getAllManufacturer(params) {
  return apiRequest("get", "/manufacturer/getAllManufacturer", {
    params: params,
  });
}

export function addManufacturer(manufacturerData) {
  return apiRequest("post", "/manufacturer/addManufacturer", manufacturerData);
}

export function deleteManufacturer(manufacturerId) {
  return apiRequest(
    "delete",
    `/manufacturer/deleteManufacturer/${manufacturerId}`
  );
}

export function editManufacturer(editData, id) {
  return apiRequest("put", `/manufacturer/editManufacturer/${id}`);
}

export function getAllSellers() {
  return apiRequest("get", "/seller/getAllSellers");
}

export function addDistributor(distributorData) {
  return apiRequest("post", "/seller/addSeller", distributorData);
}

export function deleteUser(data) {
  return apiRequest("delete", "/user/delete", data);
}

export function editDistributor(editData, id) {
  return apiRequest("put", `/seller/editSeller/${id}`, editData);
}

export function getProductByManufacturer(id) {
  return apiRequest("get", `/master/getProductByManufacturer/${id}`);
}

export function getProductVerifyRequest(params) {
  return apiRequest("get", "/master/getProductVerifyRequest", {
    params: params,
  });
}

export function actionOnDistributorRequest(id, data) {
  return apiRequest("post", `/manufacturer/approveProduct/${id}`, data);
}

export function sendProductVerifyRequest(id, data) {
  return apiRequest("post", `/master/sendProductVerifyRequest/${id}`, data);
}

export function deleteProductByDistributor(data) {
  return apiRequest("post", "/master/deleteProductBySeller", data);
}

export function addLocation(data, token) {
  return apiRequest("post", "/location/addLocation", data, token);
}

export function updateLocation(data, token) {
  return apiRequest("put", "/location/updateLocation", data, token);
}
export function importCsvTags(data, token) {
  return apiRequest(
    "post",
    "/tag/importCsvData",
    data,
    token,
    "multipart/form-data"
  );
}

export function addTag(data, token) {
  return apiRequest("post", "/tag/addTag", data, token);
}

export function getLocations(token) {
  return apiRequest(
    "get",
    "/location/getLocations",
    {},
    token,
    "application/json"
  );
}

export function getAllBrandsWithLocations(token) {
  return apiRequest(
    "get",
    "/brand/getAllBrandsWithLocation",
    {},
    token,
    "application/json"
  );
}

export function getProducts(token) {
  return apiRequest(
    "get",
    "/product/getProducts",
    {},
    token,
    "application/json"
  );
}

export function getTags(token) {
  return apiRequest("get", "/tag/getTags", {}, token, "application/json");
}

export function enableTag(data, token) {
  return apiRequest("put", "/tag/enableTag", data, token);
}

export function addSpots(data) {
  return apiRequest("post", "/spot/addSpot", data);
}

export function updateBrandStatus(data) {
  return apiRequest("post", "/brand/updateBrandStatus", data);
}

export function contactSupport(data, token) {
  return apiRequest("post", "/user/contactSupport", data, token);
}

export function forgotPassword(data) {
  return apiRequest("post", "/user/forgotPassword", data);
}

export function verifyCode(data) {
  return apiRequest("post", "/verify/otp", data);
}

export function resetPassword(data) {
  return apiRequest("post", "/user/resetPassword", data);
}

export function inviteAdmin(data, token) {
  return apiRequest("post", "/auth/inviteAdmin", data, token);
}

export function getProfile(idToken) {
  return apiRequest(
    "get",
    "/user/profile",
    {},
    idToken,
    "application/x-www-form-urlencoded"
  );
}

export function verifyUser(accessToken) {
  return apiRequest("get", `/verify/${accessToken}`);
}

export function resendVerification(data) {
  return apiRequest("post", "/resend/verification", data);
}

export function checkError(error) {
  // 2026-05-24: previously auto-logged-out on ANY 403. That kicked the user
  // out whenever a single endpoint denied permission, because Layout.jsx fires
  // 5+ simultaneous requests on dashboard mount and ANY of them 403ing wiped
  // localStorage + redirected to /. Result: login worked, then immediately
  // got kicked back out.
  //
  // Correct behavior:
  //   401 → token genuinely bad → log out, force re-auth
  //   403 → per-endpoint access denial → log it, do NOT log out
  //   other → caller decides
  const status = error?.response?.status;
  const url = error?.config?.baseURL
    ? error.config.baseURL + (error.config.url || "")
    : (error?.config?.url || "");
  if (status === 401) {
    console.warn("[aeroz] 401 from", url, "— token rejected, logging out");
    localStorage.removeItem("persist:root");
    localStorage.removeItem("accessToken");
    window.location.href = "/";
  } else if (status === 403) {
    console.warn(
      "[aeroz] 403 from",
      url,
      "— per-endpoint access denied; staying logged in. Check Cognito group/scope on this endpoint."
    );
  }
}

// rewards api

export function getRewards(token) {
  return apiRequest("get", "/reward/getAllRewardDash", {}, token);
}

export function addReward(data, token) {
  return apiRequest(
    "post",
    "/reward/addReward",
    data,
    token,
    "multipart/form-data"
  );
}

export function deleteReward(id, token) {
  return apiRequest("delete", `/reward/deleteReward/${id}`, {}, token);
}

export function editReward(data, token) {
  return apiRequest(
    "put",
    `/reward/editReward`,
    data,
    token,
    "multipart/form-data"
  );
}
